import {useQuestionTranslationStore} from 'components/QuestionTypes/shared/TranslationSection';

/** The translated highlight prompt while question translation is on and one exists; otherwise null. */
export const useTranslatedHighlightPrompt = (): string | null =>
  useQuestionTranslationStore((state) =>
    state.showTranslations && state.translationSettings.question
      ? state.translatedQuestionInfo?.highlight_prompt || null
      : null
  );
